import { useRecoilState } from "recoil";
import uiConfigAtom from "../atoms/uiConfigAtom";

function Button({ name, clickHandler, className, variant = "primary", size = "md", disabled = false }) {
    const [uiConfig] = useRecoilState(uiConfigAtom);

    // Variant styles matching FleetIO design
    const variantClasses = {
        primary: 'bg-primary hover:bg-primary-dark text-white',
        secondary: 'bg-neutral-200 hover:bg-neutral-300 text-neutral-900',
        danger: 'bg-danger hover:bg-danger-light text-white',
        outline: 'bg-transparent border-2 border-primary text-primary hover:bg-primary-light',
        ghost: 'bg-transparent text-primary hover:bg-primary-light',
        action: 'bg-primary hover:bg-primary-dark text-white',
    };

    // Size classes matching FleetIO proportions
    const sizeClasses = {
        sm: 'px-3 py-1.5 text-sm font-medium rounded-lg',
        md: 'px-4 py-2.5 text-sm font-semibold rounded-lg',
        lg: 'px-6 py-3 text-base font-semibold rounded-lg',
        xl: 'px-8 py-4 text-base font-bold rounded-lg',
        action: 'px-8 py-3.5 text-base font-semibold rounded-full',
    };

    const disabledClass = disabled ? 'opacity-60 cursor-not-allowed' : '';

    const themedStyle = className
        ? undefined
        : {
            backgroundColor: uiConfig?.button?.btnBgColor?.hex,
            color: uiConfig?.button?.btnFontColor?.hex,
            fontFamily: uiConfig?.button?.fontFamily,
            borderColor: uiConfig?.button?.btnBgColor?.hex,
        };

    const defaultClass = `flex justify-center items-center ${variantClasses[variant]} ${sizeClasses[size]} mb-2 cursor-pointer transition-all duration-200 shadow-base focus:ring-2 focus:ring-primary-light ${disabledClass}`;

    return (
        <button
            className={className || defaultClass}
            onClick={() => !disabled && clickHandler()}
            style={themedStyle}
            disabled={disabled}
        >
            {name}
        </button>
    );
}

export default Button;